import { ComponentProps } from 'react';
import { Text } from '@hopskipdrive/react-components';

export type PageHeadingProps = ComponentProps<typeof Text>;

/**
 * Static page/section heading text (e.g. "Reports", "Rider Profile").
 */
export const PageHeading = (props: PageHeadingProps) => <Text {...props} />;
